import React from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import { AlertProps, IExportedAlert } from './index.d';

const container = document.getElementById('prompt');

const Alert = (props: AlertProps) => {
  const { title, text, btnEvent, btnText, holdbackdrop = false } = props;
  const confirm = () => {
    if (typeof btnEvent === 'function') {
      btnEvent();
    }
    ReactDOM.unmountComponentAtNode(container as HTMLElement);
  };

  const cancel = () => {
    ReactDOM.unmountComponentAtNode(container as HTMLElement);
  };

  const clickBackground = (event: React.MouseEvent): void => {
    if ((event.target as HTMLElement).id === 'bgAlert' && !holdbackdrop) {
      cancel();
    }
  };

  return (
    <div id="bgAlert" className="flex flex-center bg-modal" onClick={clickBackground}>
      <div className="fade-in-down" styleName="alert">
        <div className="flex" styleName="content">
          <div styleName="center">
            <h3>{title}</h3>
            {text ? <h5 className="text-minor">{text}</h5> : null}
          </div>
        </div>
        <div className="text-primary" styleName="button" onClick={confirm}>
          {btnText || '确定'}
        </div>
      </div>
    </div>
  );
};

const ExportedAlert: IExportedAlert = {
  show(options) {
    /* eslint-disable no-param-reassign */
    if (typeof options === 'string') {
      options = {
        title: options,
      };
    }
    /* eslint-enable no-param-reassign */
    ReactDOM.render(<Alert {...options} />, container);
  },
};

export default ExportedAlert;
